<template>
  <span
    :class="['wave-loader', `wave-loader--${size}`, { 'wave-loader--mono': mono }]"
    role="status"
    :aria-label="label"
  >
    <svg class="wave-loader__logo" :viewBox="viewBox" aria-hidden="true" focusable="false">
      <g
        v-for="(wave, i) in waves"
        :key="wave.key"
        class="wave-loader__wave"
        :style="{ '--i': i }"
      >
        <path :d="wave.d" :transform="transform" :fill="mono ? 'currentColor' : wave.color" />
      </g>
    </svg>
    <span v-if="$slots.default" class="wave-loader__text"><slot /></span>
  </span>
</template>

<script>
import { LOGO_WAVES, LOGO_VIEW_BOX, LOGO_TRANSFORM } from '@/util/auth/brandLogoPaths';

export default {
  name: 'WaveLoader',
  props: {
    size: { type: String, default: 'md', validator: (v) => ['sm', 'md', 'lg'].includes(v) },
    mono: { type: Boolean, default: false },
    label: { type: String, default: 'Loading' },
  },
  data() {
    return { waves: LOGO_WAVES, viewBox: LOGO_VIEW_BOX, transform: LOGO_TRANSFORM };
  },
};
</script>

<style>
.wave-loader { display: inline-flex; align-items: center; justify-content: center; gap: 8px; vertical-align: middle; }
.wave-loader--md, .wave-loader--lg { flex-direction: column; }
.wave-loader__logo { display: block; overflow: visible; }
.wave-loader--sm .wave-loader__logo { height: 1em; width: 2.05em; }
.wave-loader--md .wave-loader__logo { height: 48px; width: 98px; }
.wave-loader--lg .wave-loader__logo { height: 96px; width: 196px; }
.wave-loader--md .wave-loader__text, .wave-loader--lg .wave-loader__text { font-size: 13px; opacity: .8; }
/* pusat animasi = tengah logo, biar ujung gelombang tetap nyatu */
.wave-loader__wave {
  transform-box: view-box;
  transform-origin: 50% 50%;
  animation: mz-wave-breathe 2.4s ease-in-out infinite;
  animation-delay: calc(var(--i) * -0.4s);
}
@keyframes mz-wave-breathe {
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(0.7); }
}
@media (prefers-reduced-motion: reduce) {
  .wave-loader__wave { animation: none; }
}
</style>
